import fetchAPI from '../../../utils/fetchApi';

type TCarValueRequest = {
  licensePlate: string;
  mileage: number;
};

export type TCarValueResponse = {
  title: string;
  price: string;
  logoUrl: string;
  constructionYear: number;
};

export default function getCarValue(params: TCarValueRequest, xsrfToken: string): Promise<TCarValueResponse> {
  return fetchAPI({
    url: `/cp/api/car-value`,
    method: 'POST',
    payload: params,
    xsrfToken,
  });
}
